import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AdvHero() {
  const { t } = useTranslation();

  return (
    <section className="relative bg-white pt-[72px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="http://geel.fp.08wx.cn/images/efaae0ed4bf3648ee6b958fe13e6bc46.jpg"
          alt="Advantages Hero"
          className="w-full h-full object-cover object-top opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white" />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-transparent to-white/90" />
      </div>

      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: 'linear-gradient(rgba(255,45,120,1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,45,120,1) 1px, transparent 1px)',
          backgroundSize: '80px 80px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto px-6 py-24 md:py-36">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-8">
          <Link to="/" className="text-xs text-gray-400 hover:text-primary transition-colors">{t('breadcrumb.home')}</Link>
          <i className="ri-arrow-right-s-line text-gray-300 text-sm" />
          <span className="text-xs text-primary">{t('breadcrumb.advantages')}</span>
        </div>

        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
            <span className="text-primary text-xs font-medium uppercase tracking-widest">{t('advantages.hero.tag')}</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-heading font-black text-gray-900 mb-6 leading-tight">
            {t('advantages.hero.title')}
            <br />
            <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(135deg, #FF2D78 0%, #FF8FAB 100%)' }}>
              {t('advantages.hero.highlight')}
            </span>
          </h1>

          <p className="text-gray-500 text-lg leading-relaxed max-w-2xl mb-10">
            {t('advantages.hero.desc1')}
            {t('advantages.hero.desc2')}
          </p>

          {/* Quick nav pills */}
          <div className="flex flex-wrap gap-3">
            {Array.from({ length: 5 }, (_, i) => t(`advantages.hero.pill.${i}`)).map((label, i) => (
              <span
                key={i}
                className="px-4 py-1.5 bg-white border border-primary/20 text-gray-500 text-xs rounded-full shadow-sm"
              >
                {String(i + 1).padStart(2, '0')} · {label}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </section>
  );
}
